export default "__VITE_ASSET__BEC_sp0i__"